import enviro from 'enviro';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import { useConnectDotComUser } from '../connectDotComQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const connectDotComDomain = enviro.isQa() ? 'connectqa.co' : 'connect.com';
export const ConnectDotComUpsell = ({
  userId,
  onClickJoinConnectDotCom,
  onClickViewConnectDotCom
}) => {
  const {
    connectDotComUser,
    connectDotComUserLoading
  } = useConnectDotComUser(userId);
  if (connectDotComUserLoading) return null;
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    direction: "column",
    children: connectDotComUser ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.connectDotCom.upsellViewTitle"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.connectDotCom.upsellViewDescription"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        href: `https://${connectDotComDomain}/member/${connectDotComUser.userName}`,
        onClick: onClickViewConnectDotCom,
        target: "_blank",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.connectDotCom.view"
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.connectDotCom.upsellJoinTitle"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.connectDotCom.upsellJoinDescription"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        href: `https://${connectDotComDomain}/introduction`,
        onClick: onClickJoinConnectDotCom,
        target: "_blank",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.connectDotCom.join"
        })
      })]
    })
  });
};